import React from 'react';
import {
  Layout, Menu, Avatar, Modal
} from 'antd';
import 'antd/dist/antd.css';
import {connect} from 'react-redux'
import { bindActionCreators } from 'redux';
import { ActionCreators } from '../redux/actions';
import { Redirect} from "react-router-dom";
import logo from '../assets/aba_taxi.png';
import AdminPassword from "./AdminPassword";
// import LanguageSelector from './LanguageSelector';

const { Header } = Layout;

class Navbar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      redirectHome: false,
      modalVisible: false,
    };
  }

  redirectHome() {
    this.setState({redirectHome: true})
  }

  render() {
    const {
      admin,
      company_admin
    } = this.props.app;

    // console.log(`user >> `, user);

    return (
      <Header className="header" style={{background: 'linear-gradient(to right,#006ABF 0,#054f8a 100%)'}}>
        <Modal
          title="編輯"
          visible={this.state.modalVisible}
          footer={null}
          style={{ maxWidth: 800 }}
          width="90%"
          onCancel={() => {
            this.setState({modalVisible: false});
          }}
        >
          <AdminPassword
            openModal={(value) => {
              this.setState({modalVisible: value});
            }}
          />
        </Modal>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <div style={{width: 180}}>
            <img onClick={() => { this.redirectHome(); }} style={{height: 60}} src={logo} alt="" />
          </div>
          <div>
            {/* <LanguageSelector /> */}
            <Menu
              theme="dark"
              mode="horizontal"
              style={{ lineHeight: '64px', float: 'right', background: 'rgba(255, 0, 0, 0)'}}
            >
              <Menu.Item
                onClick={() => {
                  this.setState({modalVisible: true});
                }}
              >
                修改密碼
              </Menu.Item>
              <Menu.Item>
                <Avatar style={{margin: '0 10px'}}>{admin.nickname?.charAt(0)}</Avatar>
                {admin.admin_id!= null?admin.nickname: company_admin.nickname}
              </Menu.Item>
            </Menu>
          </div>
        </div>
        {
          this.state.redirectHome === true
            ? <Redirect to="/" />
            : null
        }
      </Header>
    )
  }
}

function mapStateToProps(state) {
  return {
    app: state.app
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navbar);
